<template>
  <div class="">
    <ssam-talk-filter-link
        :filterLayout="filterLayout"
        :filterData="filterSet.filter"
        :paginationData="filterSet.page"
        :category="category"
    ></ssam-talk-filter-link>
    <ssam-talk-list-link
        :listLayout="listLayout"
        :paginationData="filterSet.page"
        :ssam-talk-data="List"
    ></ssam-talk-list-link>
    <pagination-link
        :paginationLayout="paginationLayout"
        :paginationData="filterSet.page"
    ></pagination-link>
  </div>
</template>

<script>

import listMixins from "@/mixins/listMixins";
import filterMixins from "@/mixins/filterMixins";
import ssamtalkUtil from "@/components/ssamtalk/ssamtalkUtil";
import alertMixins from "@/mixins/alertMixins";
import util from "@/mixins/util";
import DeleteClass from "@/mixins/deleteClass";
import PaginationLink from "@/components/ssamtalk/link/PaginationLink.vue";
import SsamTalkListLink from "@/components/ssamtalk/link/SsamTalkListLink.vue";
import SsamTalkFilterLink from "@/components/ssamtalk/link/SsamTalkFilterLink.vue";

const {filterConfig} = ssamtalkUtil;
export default {
  name: "SsamTalkCategoryListComponent",
  mixins: [filterMixins, listMixins, ssamtalkUtil, alertMixins],
  components: {SsamTalkFilterLink, SsamTalkListLink, PaginationLink},
  provide() {
    return {
      setPage: this.setPage,
      setFilter: this.setFilter,
      setSort: this.setSort,
      ssamTalkListSetData: this.setData,
    };
  },
  props: {
    ssamTalkType: '',
  },
  data() {
    return {
      filterLayout: "",
      listLayout: "",
      paginationLayout: "",

      getFunc: "",
      getCategoryFunc: '',
      listApiParamSet: {},
      pageRow: 10,
      paginationType: "",
      deleteKeyName: "",
      deleteFunc: "",
      deleteApiParamSet: {},
      deleteSuccessType: 1,
      deleteFailTypes: {},
      isCategory: false,
      category: [],

      selectArr: [],
      deleteIndex: 0,
      DeleteClass: null,
      deleteLastIndex: 0,
    };
  },
  created() {
    this.initConfig();
    this.setFilterConfig(filterConfig);
    this.setParserType("url", this.$route.fullPath);
  },
  mounted() {
    this.getList(true);
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    setData(type, value) {
      this[type] = value;
    },
    initConfig() {
      let config = this.returnSsamTalkConfig(this.ssamTalkType);
      this.listLayout = config.listLayout;
      this.filterLayout = config.filterLayout;
      this.paginationLayout = config.paginationLayout;

      this.getFunc = config.getFunc;
      this.getCategoryFunc = config.getCategoryFunc;
      this.listApiParamSet = config.listApiParamSet;
      this.pageRow = config.pageRow;
      this.paginationType = config.paginationType;

      this.deleteKeyName = config.deleteKeyName;
      this.deleteFunc = config.deleteFunc;
      this.deleteApiParamsSet = config.deleteApiParamsSet;
      this.deleteSuccessType = config.deleteSuccessType;
      this.deleteFailTypes = config.deleteFailTypes;

      this.isCategory = config.isCategory;
      if (config.pageRow && config.pageRow !== this.filterSet.page.size) {
        this.pageRow = config.pageRow;
        this.filterSet.page.size = config.pageRow;
        this.pageClass.setterPage("size", this.pageRow);
      }

      let listOptions = {
        url: this.$api.$ssamtalk[this.getFunc],
        defaultParams: this.listApiParamSet,
      };

      this.initList("api", listOptions);

    },


  },
  watch: {},
};
</script>
